"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback } from "react";
import makeStyles from "../../theming/make-styles.js";
import renderWrappedTooltipOrChild from "../tooltip/render-wrapped-tooltip-or-child.js";
const useStyles = makeStyles()((theme, { divider }) => ({
    tag: {
        "position": "relative",
        "&:focus, &:active": {
            zIndex: 1,
        },
        "&:not(:first-child)": {
            marginLeft: divider ? undefined : `-${theme.spacing(1)}`,
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
        },
        "&:not(:last-child)": {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
        },
    },
    group: {
        display: "inline-flex",
        columnGap: divider ? theme.spacing(1) : undefined,
        borderRadius: theme.size(4),
    },
}));
export const TagGroup = React.forwardRef(function TagGroup(_a, ref) {
    var { children, className, color = "primary", disabled, divider, size = "medium", variant = "filled" } = _a, props = __rest(_a, ["children", "className", "color", "disabled", "divider", "size", "variant"]);
    const { classes, cx } = useStyles({ divider });
    const cloneTag = useCallback((child, index) => React.cloneElement(child, Object.assign(Object.assign({ color,
        disabled }, child.props), { key: index, className: cx(classes.tag, child.props.className), size, variant: variant.startsWith("faded") && child.props.variant === "outline" ? "faded-outline" : child.props.variant || variant })), [classes.tag, color, cx, disabled, size, variant]);
    const items = React.Children.map(children, (child, index) => {
        return renderWrappedTooltipOrChild(child, el => !!el && cloneTag(el, index));
    });
    return (_jsx("div", Object.assign({ ref: ref, className: cx(classes.group, className), "data-component": "tag-group" }, props, { children: items })));
});
export default TagGroup;
//# sourceMappingURL=tag-group.js.map